// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Refer.module.css";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { BsWhatsapp } from "react-icons/bs";
// import { BsChevronDown } from 'react-icons/bs';
// import { BsPerson } from 'react-icons/bs';
// import { BsCash } from 'react-icons/bs';

// import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
// import CopyToClipboard from "react-copy-to-clipboard";
// import { FaTelegramPlane } from "react-icons/fa";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);
//   const theme = localStorage.getItem('theme')


//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);

//   const [cardData, setGame] = useState([]);

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(user.referral_code);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   const copyLink = (e) => {
//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referal Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   if (user === undefined) {
//     return null;
//   }

//   const referralText = `Hi Friends, Play wintoxludo.com Ludo and earn 10000 daily. Download Indian App wintoxludo.com
//   बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
//    दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
//     NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
//     100% भरोसेमंद प्लेटफार्म । 24 hours support https://wintoxludo.com/login/${user.referral_code}
    
//     Your ReferralCode is -${user.referral_code}.`


//   // language 


//   const translations = {
//     hi: {
//       referral: 'आपकी रेफरल कमाई',
//       referPerson: 'आमंत्रित किये दोस्त | ',
//       referEarn: 'रेफरल कमाई  ',
//       referCode: 'रेफरल कोड ',
//     },
//     en: {
//       referral: 'Your Referral Earnings',
//       referPerson: 'Referred Players',
//       referEarn: 'Referral Earning',
//       referCode: 'Referral Code',
//     },
//   };

//   // change theme 

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : 'black',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };


//   return (
//     <>
//       {/* <Header user={user} /> */}
//       <div style={styles}>
//         <div
//           className="leftContainer mt-5 pt-5"
//           style={{ ...styles, height: "100%" }}
//         >
//           <section className="referUnique">

//             {/* NEW STYLE INTRO CARD */}
//             <div className="introRibbonCard">
//               <div className="ribbonBar"></div>

//               <div className="ribbonContent">
//                 <img src="/images/refer.png" className="refer_icon" />
//                 <div>
//                   <h3>Refer & Earn</h3>
//                   <p>You can earn more more real money doing refer to your friends</p>
//                 </div>
//               </div>
//             </div>

//             {/* REFERRAL CODE CARD */}
//             <div className="codeLayerCard">
//               <label>Your Referral Code</label>

//               <div className="codeRow">
//                 <strong>{user.referral_code}</strong>

//                 <button className="copySmall" onClick={(e) => copyCode(e)}>
//                   Copy
//                 </button>
//               </div>
//             </div>
//             <div className="whatsapp_share_btn">
//               <a
//                 href={`whatsapp://send?text=Play%20On%20wintoxludo.com%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2Fwintoxludo.comludo.com%2Flogin%2F${user.referral_code}`}



//               >
//                 <BsWhatsapp className="icons" />
//                 <span class="ml-2">Whatsapp</span>
//               </a>
//             </div>

//             {/* STATS */}
//             <div className="statsFlex">

//               <div className="statLayerCard">
//                 <div>
//                   <h4>{user.referral_user?.length}</h4>
//                   <p>People Referred</p>
//                 </div>
//                 <img src="/images/trophy.png" className="stat_icon" />
//               </div>

//               <div className="statLayerCard">
//                 <div>
//                   <h4>₹{user.referral_earning}</h4>
//                   <p>Total Earned</p>
//                 </div>
//                 <img src="/images/monney.png" className="stat_icon" />
//               </div>

//             </div>

//           </section>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;


// import React, { useContext } from "react";
// import Swal from "sweetalert2";
// import { BsWhatsapp } from "react-icons/bs";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./ReferUI.css"; 

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     Swal.fire({
//       icon: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1000,
//     });
//   };

//   // const shareText = `Play WINTOXLUDO and earn daily! Join using my code: ${user.referral_code} \nLink: https://wintoxludo.com/login/${user.referral_code}`;
// const shareText = `🔥 Hello Dost 👋

// Apni Site WINTOXLUDO par Game Khelo aur Daily Paisa Jeeto 💸

// 🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

// 🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

// 👉 Join Now:
// https://wintoxludo.com/login/${user.referral_code}

// 🎯 Referral Code: ${user.referral_code}`;
//   return (
//     <div className="refer-page-wrapper leftContainer mt-5 pt-5">
//       <div className="refer-main-container">
        
//         {/* Title Section */}
//         <div className="refer-title-section">
//           <h1>Invite & Earn</h1>
//           <p>Share your code and get 3% of your friend's winnings!</p>
//         </div>

//         {/* Unique Referral Code Card */}
//         <div className="referral-code-card">
//           <label>YOUR UNIQUE REFERRAL CODE</label>
//           <div className="code-row">
//             <div className="dashed-code-box">
//               {user.referral_code}
//             </div>
//             <button className="copy-btn-blue" onClick={copyCode}>
//               <FiCopy /> Copy
//             </button>
//           </div>
//         </div>

//         {/* WhatsApp Button */}
//         <a 
//           href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
//           className="whatsapp-btn-full"
//         >
//           <BsWhatsapp className="wa-icon" /> WhatsApp
//         </a>

//         {/* Stats Divider */}
//         <div className="stats-divider">
//           <div className="divider-line"></div>
//           <span>YOUR STATS</span>
//           <div className="divider-line"></div>
//         </div>

//         {/* Stats Grid */}
//         <div className="refer-stats-grid">
//           <div className="stat-box purple-box">
//             <div className="stat-content">
//               <h2>{user.referral_user?.length || 0}</h2>
//               <p>Total Players</p>
//             </div>
//             <img src="/images/trophy-bg.png" alt="" className="box-bg-icon" />
//           </div>

//           <div className="stat-box orange-box">
//             <div className="stat-content">
//               <h2>₹{user.referral_earning || 0}</h2>
//               <p>Total Earnings</p>
//             </div>
//             <img src="/images/money-bag.png" alt="" className="box-bg-icon" />
//           </div>
//         </div>

//         {/* How It Works */}
//         <div className="how-it-works-card mb-5">
//           <h3><span className="info-icon">🛈</span> How It Works</h3>
          
//           <div className="step-row">
//             <div className="step-number">01</div>
//             <p>You can refer and <strong>Earn 3%</strong> of your referral winning, every time.</p>
//           </div>

//           <div className="step-row">
//             <div className="step-number">02</div>
//             <p>If your player wins <strong>₹10,000</strong>, you instantly get <strong>₹300</strong> in your wallet.</p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
      background: 'rgba(20, 25, 40, 0.9)',
      color: '#ffffff',
    });
  };

  const shareText = `🔥 Hello Dost 👋

Apni Site WINTOXLUDO par Game Khelo aur Daily Paisa Jeeto 💸

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://wintoxludo.com/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;

  return (
    <>
      <style>
        {`
          .premium-refer-container {
            background: linear-gradient(135deg, #0a0f1c 0%, #000000 100%);
            min-height: 100vh;
            color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow-x: hidden;
          }
          
          .slide-up {
            animation: slideUp 0.6s ease-out forwards;
          }

          .glass-card {
            background: rgba(20, 25, 40, 0.7);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 15px 35px rgba(0,0,0,0.5);
            transition: all 0.3s ease;
          }

          .glass-card:hover {
            transform: translateY(-5px);
          }

          .whatsapp-theme {
            background: rgba(37, 211, 102, 0.1);
            border: 1px solid rgba(37, 211, 102, 0.2);
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
            border-radius: 12px;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            transition: all 0.3s ease;
          }

          .whatsapp-theme:hover {
            background: rgba(37, 211, 102, 0.2);
            box-shadow: 0 5px 15px rgba(37, 211, 102, 0.2);
            border-color: rgba(37, 211, 102, 0.4);
            color: #ffffff;
          }

          .refer-stats-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            width: 100%;
          }

          .copy-btn-gold {
            background: #f0c022;
            color: #000000;
            border: none;
            border-radius: 8px;
            padding: 0 20px;
            font-weight: bold;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
          }

          .copy-btn-gold:hover {
            background: #d4a71c;
            transform: scale(1.02);
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="premium-refer-container leftContainer mt-5 pt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 100%', maxWidth: '650px', margin: '0 auto', padding: '20px' }}>
          
          {/* Title Section */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }} className="slide-up">
            <h2 style={{ fontSize: '28px', fontWeight: 'bold', margin: '10px 0 5px 0', color: '#fff', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Invite & <span style={{ color: '#f0c022' }}>Earn</span>
            </h2>
            <p style={{ color: '#8892b0', fontSize: '13px', margin: '0' }}>
              Share your code and get <strong style={{ color: '#00ff88' }}>3%</strong> of your friend's winnings!
            </p>
          </div>

          {/* Unique Referral Code Card */}
          <div className="glass-card slide-up" style={{ padding: '20px', marginBottom: '25px', animationDelay: '0.1s' }}>
            <div style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '12px', letterSpacing: '1px' }}>
              YOUR UNIQUE REFERRAL CODE
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ 
                flex: 1, 
                background: 'rgba(0, 0, 0, 0.5)', 
                border: '1px dashed #f0c022', 
                borderRadius: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontSize: '18px', 
                fontWeight: 'bold', 
                color: '#f0c022', 
                padding: '12px', 
                letterSpacing: '2px' 
              }}>
                {user.referral_code}
              </div>
              <button className="copy-btn-gold" onClick={copyCode}>
                <FiCopy /> Copy
              </button>
            </div>
          </div>

          {/* WhatsApp Button */}
          <div className="slide-up" style={{ animationDelay: '0.2s', marginBottom: '30px' }}>
            <a 
              href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
              className="whatsapp-theme"
            >
              <BsWhatsapp style={{ fontSize: '22px', marginRight: '10px', color: '#25d366' }} /> 
              Share via WhatsApp
            </a>
          </div>

          {/* Stats Divider */}
          <div className="slide-up" style={{ display: 'flex', alignItems: 'center', margin: '25px 0', animationDelay: '0.3s' }}>
            <div style={{ flex: 1, height: '1px', background: 'rgba(255, 255, 255, 0.1)' }}></div>
            <div style={{ padding: '0 15px', color: '#8892b0', fontSize: '12px', fontWeight: 'bold', letterSpacing: '2px' }}>
              YOUR STATS
            </div>
            <div style={{ flex: 1, height: '1px', background: 'rgba(255, 255, 255, 0.1)' }}></div>
          </div>

          {/* Stats Grid */}
          <div className="refer-stats-grid slide-up" style={{ animationDelay: '0.4s', marginBottom: '35px' }}>
            <div className="glass-card" style={{ padding: '20px 15px', textAlign: 'center', borderBottom: '3px solid #0088cc' }}>
              <h2 style={{ color: '#ffffff', fontSize: '26px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
                {user.referral_user?.length || 0}
              </h2>
              <p style={{ color: '#8892b0', fontSize: '12px', margin: 0, textTransform: 'uppercase', fontWeight: '600' }}>
                Total Players
              </p>
            </div>

            <div className="glass-card" style={{ padding: '20px 15px', textAlign: 'center', borderBottom: '3px solid #00ff88' }}>
              <h2 style={{ color: '#00ff88', fontSize: '26px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
                ₹{user.referral_earning || 0}
              </h2>
              <p style={{ color: '#8892b0', fontSize: '12px', margin: 0, textTransform: 'uppercase', fontWeight: '600' }}>
                Total Earnings
              </p>
            </div>
          </div>

          {/* How It Works */}
          <div className="glass-card slide-up" style={{ padding: '25px 20px', animationDelay: '0.5s', marginBottom: '40px' }}>
            <h3 style={{ color: '#ffffff', fontSize: '16px', margin: '0 0 20px 0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', paddingBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#f0c022', fontSize: '18px' }}>🛈</span> How It Works
            </h3>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '18px' }}>
              <div style={{ background: 'rgba(240, 192, 34, 0.1)', color: '#f0c022', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', marginRight: '15px', border: '1px solid rgba(240, 192, 34, 0.2)' }}>
                01
              </div>
              <p style={{ color: '#8892b0', fontSize: '14px', margin: 0, lineHeight: '1.6' }}>
                You can refer and <strong style={{ color: '#ffffff' }}>Earn 3%</strong> of your referral winning, every time.
              </p>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ background: 'rgba(240, 192, 34, 0.1)', color: '#f0c022', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', marginRight: '15px', border: '1px solid rgba(240, 192, 34, 0.2)' }}>
                02
              </div>
              <p style={{ color: '#8892b0', fontSize: '14px', margin: 0, lineHeight: '1.6' }}>
                If your player wins <strong style={{ color: '#ffffff' }}>₹10,000</strong>, you instantly get <strong style={{ color: '#00ff88' }}>₹300</strong> in your wallet.
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Refer;